module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-fpw"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "fpw-modal-title"
  }, [_vm._v("QUÊN MẬT KHẨU")]), _c('span', {
    staticClass: "fpw-modal-btn-close material-icons",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("close")])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "fpw-content"
  }, [_vm._v("Nhập email đã đăng ký của bạn để nhận lại mật khẩu mới qua email:")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-group fpw-email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "email",
      "name": "email",
      "placeholder": "Nhập email",
      "required": "required",
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "modal-footer fpw-custom-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "fpw-btn-continue btn",
    on: {
      "click": function($event) {
        return _vm.validateForgot()
      }
    }
  }, [_vm._v("Gửi yêu cầu")])])]), _c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('a', {
    staticClass: "fpw-btn-back btn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Hủy")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74835c24","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/ForgotPassword.vue
// module id = 1607
// module chunks = 0